import React from 'react';

import GardenNftDrawer from '../GardenNftDrawersShared/GardenNftDrawer';
import {
  STEP,
  useGardenNftDrawerStore,
} from '../GardenNftDrawersShared/useGardenNftDrawer';
import ConfirmContent from './ConfirmContent';
import DefaultContent from './DefaultContent';
import SuccessContent from './SuccessContent';

function GardenStakeNftDrawer() {
  const { step } = useGardenNftDrawerStore();

  return (
    <>
      <GardenNftDrawer mode={'STAKE'}>
        {step === STEP.default && <DefaultContent />}
        {step === STEP.confirming && <ConfirmContent />}
        {step === STEP.success && <SuccessContent />}
      </GardenNftDrawer>
    </>
  );
}

export default GardenStakeNftDrawer;
